/**
 * DevExtreme (esm/__internal/core/r1/runtime/inferno/portal.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    createPortal
} from "inferno";
export const Portal = _ref => {
    let {
        container: container,
        children: children
    } = _ref;
    if (container) {
        return createPortal(children, container)
    }
    return null
};
